import {Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../pipelines.service";
import {Subscription} from "rxjs";
import PipelineField from "../../../interfaces/pipeline-field";
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../services/data-format.service";
import ProjectDate from "../../../interfaces/project-date";

@Component({
  selector: 'pipelines-table',
  standalone: false,
  templateUrl: './pipelines-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pipelines-table.component.scss',
})
export class PipelinesTableComponent implements OnInit, OnChanges{
  public pipelineFieldSubscription: Subscription
  @Input() projects:any[]
  constructor(public pipelineService: PipelinesService, public dataFormat: DataFormatService) {
  }

  public headers: string[] = []
  public tableFields: string[]  = []
  public data: MatTableDataSource<any> = new MatTableDataSource()
  public tableFormats:Map<string,string> = new Map<string,string>

  ngOnInit() {
    this.pipelineFieldSubscription = this.pipelineService.fields$.subscribe((results: PipelineField[]) => {
      this.headers = []
      this.tableFields = []

      results.forEach((field:PipelineField) => {
        this.tableFormats.set(field.display_name, field.display_format)
        this.tableFields.push(field.display_name)
        this.headers.push(field.display_name.split(" ").join("_").toLowerCase())
      })
    })

    this._buildTable()

  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['projects']){
      this._buildTable()
    }
  }

  private _buildTable(){
    let tags:any []
    this.pipelineService.projectsTags$.subscribe((results) => {
      let expandedProjs:any[] = []
      for(let i=0; i < this.projects.length; i++){
        let obj = {
          ...this.projects[i],
          isExpanded: false,
          details: null,
          tags: results[this.projects[i].id]
        }
        expandedProjs.push(obj)
      }
      this.data = new MatTableDataSource(expandedProjs)
    })

  }

  public getProjectLink(row:any, field:string){
    return this.dataFormat.formatLink({
      id: row['id'],
      name: row[field],
      __typename: 'Project'
    })
  }

  isStringField(row:any, field:string){
    return typeof row[field]==='string'
  }

  public itemIsPastDate(row:any, field:string){
    return (field==='LOI Maturity' || field==='LOI Closing Date' || field === 'LOI Expiration') && (new Date(row[field]).setHours(0,0,0,0) < new Date().setHours(0,0,0,0))
  }

  public toggleExpandedRow(row: any){
    row.isExpanded = !row.isExpanded
    this.pipelineService.getPipelineSingle(row.id).subscribe((response:any) => {
      row.details = this.pipelineService.parseField(response.data.getSinglePipeline)
      let pricingDetails = response.data.project.projectPricingDetail
      let pricingDates = response.data.project.projectDates?.filter((date: ProjectDate) => date.dateType.model=='project_pricing')
      row.details = {
        ...row.details,
        non_cra_execution: pricingDetails?.non_cra_execution ?? null,
        pricingDates: pricingDates
      }
    })
  }


  public parseHeaderFieldName(field: string): string {
    return field.split(" ").join("_")
  }

  protected readonly JSON = JSON;
  protected readonly Array = Array;
  protected readonly Object = Object;
}
